<div class="container pt-4 pb-5">
  <div class="row">
    <div class="col-md-6">
      <h3 class="pb-4">
        Sidekiq Cron Jobs &nbsp;
        <small>
          <app-badge badgeType="primary">{{ cronJobs.length }}</app-badge>
          &nbsp;
          <br />
          <button type="button" class="btn btn-primary" [disabled]="loadingCron" *ngIf="!reminderCronPresent" (click)="startReminderCron()">Start Reminder Cron (every hour)</button>
        </small>
      </h3>
      <div class="card mb-3" *ngFor="let cronJob of cronJobs">
        <h4 class="card-header">{{ cronJob.name }}</h4>
        <div class="card-body">
          <h5 class="card-title">{{ cronJob.cron_str }}</h5>
          <p class="card-text">
            <b>Cron:</b>
            &nbsp;{{ cronJob.cron }}
            <br />
            <b>Status:</b>
            &nbsp;
            <app-badge badgeType="success" *ngIf="cronJob.status == 'enabled'">
              {{ cronJob.status }}
            </app-badge>
            <app-badge badgeType="warning" *ngIf="cronJob.status != 'enabled'">
              {{ cronJob.status }}
            </app-badge>
          </p>
          <div class="btn-group">
            <button type="button" class="btn btn-primary" [disabled]="loadingCron || cronJob.processing" (click)="enqueCron(cronJob)">Enque now</button>
            <button type="button" class="btn btn-primary" *ngIf="cronJob.status == 'disabled'" [disabled]="loadingCron || cronJob.processing" (click)="enableCron(cronJob)">Enable</button>
            <button type="button" class="btn btn-warning" *ngIf="cronJob.status == 'enabled'" [disabled]="loadingCron || cronJob.processing" (click)="disableCron(cronJob)">Disable</button>
            <button type="button" class="btn btn-danger" [disabled]="loadingCron || cronJob.processing" (click)="destroyCron(cronJob)">Destroy</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <h3 class="pb-4">Sidekiq Status</h3>
      <div *ngIf="!sidekiqInfo || !sidekiqInfo.processset_size || sidekiqInfo.processset_size < 1">
        <h4 class="py-5 text-center">
          <app-badge badgeType="info">Not Running</app-badge>
        </h4>
      </div>
      <div *ngIf="sidekiqInfo && sidekiqInfo.processset_size && sidekiqInfo.processset_size > 0">
        <div class="card mb-3" *ngFor="let processSet of sidekiqInfo.processsets">
          <h4 class="card-header">{{ processSet.queues }}</h4>
          <div class="card-body">
            <p class="card-text">
              <b>Busy:</b>
              &nbsp;{{ processSet.busy }}
              <br />
              <b>Started:</b>
              &nbsp;{{ processSet.started }}
              <br />
              <b>PID:</b>
              &nbsp;{{ processSet.pid }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
